import { Component } from '@angular/core';

@Component({
    selector: 'app-upload-attachment-icon',
    templateUrl: './upload-attachment-icon.component.html',
    styleUrls: ['./upload-attachment-icon.component.scss'],
    standalone: false,
})
export class UploadAttachmentIconComponent {}
